// TODO: AVOID TO USE THIS CONSTANT. USE auth-routes.constant
export class OAuthConstants {

  public static readonly ACCESS_TOKEN = 'access_token';
  public static readonly ID_TOKEN = 'id_token';
  public static readonly TOKEN_RECEIVED_EVENT = 'token_received';
  public static readonly LOGOUT = 'logout';
  public static readonly OAUTH_REQUESTED_DOMAIN = 'OAUTH_REQUESTED_DOMAIN';
  public static readonly APP_NAME = 'linckia';
  public static readonly LOGIN_CHALLENGE = 'login_challenge';
  public static readonly CONSENT_CHALLENGE = 'consent_challenge';
  public static readonly DOMAIN = 'domain';
  public static readonly LOGIN_ROUTE = '/uas/portal/auth/login';
  public static readonly UNKNOWN_DOMAIN = 'DOMAIN_UNKNOWN';
  public static readonly INTROSPECT_ERROR = 'error';
  public static readonly MAINTENANCE_NOTICE = '/uas/portal/maintenance-notice';
  public static readonly GUID = 'guid';
  public static readonly LOGIN_INITIATE_TIME = 'LOGIN_INITIATE_TIME';
  public static readonly OPENID_ROUTE = '/uas/portal/auth/openid-callback';
  public static readonly LOGIN_CHALLENGE_EXPIRY_DURATION = 'loginChallengeExpiryDuration';
  public static readonly TARGET_URL = 'targetUrl';
  public static readonly SAML_LOGIN_ROUTE = '/uas/saml/sp/login';
  public static readonly PASSWORD_POLICY_COMPLEXITY_NOTE = 'Password should contain upper case, lower case, numbers';
  public static readonly DISABLE_NOTICE = '/uas/portal/disable-notice';
  public static readonly RESET_URL = '/uas/portal/auth/reset';
  public static readonly MFA_URL = '/uas/portal/auth/mfa';
}
